import { render, staticRenderFns } from "./ChatWithUs.vue?vue&type=template&id=0d8fc795"
import script from "./ChatWithUs.vue?vue&type=script&lang=js"
export * from "./ChatWithUs.vue?vue&type=script&lang=js"
import style0 from "./ChatWithUs.vue?vue&type=style&index=0&id=0d8fc795&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports